var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "img-des-dialog",
          attrs: { title: _vm.$t("trainingVideo"), visible: "", width: "62%" },
          on: { close: _vm.onCancel },
        },
        [
          _c(
            "div",
            { staticClass: "img-des-cls" },
            _vm._l(3, function (index) {
              return _c(
                "div",
                { key: index, staticClass: "block" },
                [
                  _c("div", {
                    staticClass: "title-cls",
                    domProps: {
                      innerHTML: _vm._s(
                        index == 1
                          ? _vm.imgTitle1
                          : index == 2
                          ? _vm.imgTitle2
                          : _vm.imgTitle3
                      ),
                    },
                  }),
                  _c(
                    "el-image",
                    {
                      staticClass: "img-cls",
                      attrs: {
                        src:
                          index == 1
                            ? _vm.img1
                            : index == 2
                            ? _vm.img2
                            : _vm.img3,
                        fit: "fill",
                      },
                      on: {
                        click: function ($event) {
                          return _vm.chooseVideo(index)
                        },
                      },
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "image-slot",
                          attrs: { slot: "placeholder" },
                          slot: "placeholder",
                        },
                        [
                          _vm._v("\n                        加载中"),
                          _c("span", { staticClass: "dot" }, [_vm._v("...")]),
                        ]
                      ),
                      _c(
                        "div",
                        {
                          staticClass: "image-slot",
                          attrs: { slot: "error" },
                          slot: "error",
                        },
                        [_c("i", { staticClass: "el-icon-picture-outline" })]
                      ),
                    ]
                  ),
                ],
                1
              )
            }),
            0
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "video-player-cls",
          attrs: {
            title: "",
            visible: _vm.videoDisplay,
            "close-on-click-modal": false,
            "append-to-body": "",
            width: "62%",
            "before-close": _vm.handleCloseVideo,
          },
          on: {
            "update:visible": function ($event) {
              _vm.videoDisplay = $event
            },
          },
        },
        [
          _vm.videoDisplay
            ? _c(
                "video",
                {
                  attrs: {
                    width: "100%",
                    controls: "",
                    id: "video",
                    oncontextmenu: "return false",
                    controlslist: "nodownload",
                    autoplay: "",
                  },
                },
                [
                  _c("source", {
                    attrs: { src: _vm.video, type: "video/mp4" },
                  }),
                  _vm._v(
                    "\n            您的浏览器不支持 video 标签。\n        "
                  ),
                ]
              )
            : _vm._e(),
          _c("div", { staticClass: "video-mask" }, [
            _vm._v(
              "\n            " +
                _vm._s(_vm.$t("head_video_mask")) +
                "\n        "
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }